import React from 'react';
export const SoftCard = ({ children, className = '', header, footer }) => {
    return (React.createElement("div", { className: `bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden ${className}` },
        header && (React.createElement("div", { className: `p-4 border-b border-gray-200 bg-gradient-to-r from-gray-50 to-white ${header.className || ''}` },
            React.createElement("h3", { className: "font-medium text-gray-700" }, header.title),
            header.subtitle && (React.createElement("p", { className: "text-sm text-gray-500 mt-1" }, header.subtitle)))),
        React.createElement("div", { className: "p-4" }, children),
        footer && (React.createElement("div", { className: `p-3 bg-gray-50 border-t border-gray-200 ${footer.className || ''}` }, footer.children))));
};
export default SoftCard;
